import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/PAYMENT_MODAL';

export const {action: showPaymentModal} = createAction(
    `${domain}/SHOW`,
    (billPayerId, institutionId, itemId, settings, relationId, invoiceId, readOnly, isBillPayerSelectDisabled) => ({
        billPayerId,
        settings,
        institutionId,
        itemId,
        relationId,
        invoiceId,
        readOnly,
        isBillPayerSelectDisabled,
    }),
);

export const {action: hidePaymentModal} = createAction(`${domain}/HIDE`, () => null);

export const {
    action: fetchAll,
    success: fetchAllSuccess,
    failed: fetchAllFailed,
} = createAction(
    `${domain}/FETCH_ALL`,
    (institutionId, billPayerId) => ({institutionId, billPayerId}),
    invoices => ({invoices}),
);

export const {
    action: fetchBalance,
    success: fetchBalanceSuccess,
    failed: fetchBalanceFailed,
} = createAction(
    `${domain}/FETCH_BALANCE`,
    (institutionId, billPayerId, limit) => ({institutionId, billPayerId, limit}),
    (accountItems, balance) => ({accountItems, balance}),
);

export const {
    action: confirmPayment,
    success: confirmPaymentSuccess,
    failed: confirmPaymentFailed,
} = createAction(`${domain}/CONFIRM_PAYMENT`, (institutionId, billPayerId, payment) => ({
    institutionId,
    billPayerId,
    payment,
}));

export const {
    action: denyPayment,
    success: denyPaymentSuccess,
    failed: denyPaymentFailed,
    aborted: denyPaymentAborted,
} = createAction(`${domain}/DENY_PAYMENT`, (institutionId, billPayerId, payment) => ({
    institutionId,
    billPayerId,
    payment,
}));
/*  */
